import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    color: 'var(--color-colorPrimary-dark-3)',
    border: '1px solid',
    display: 'inline-flex',
    height: 32,
    padding: '0',
    borderColor: 'var(--color-colorPrimary-dark-3)',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: 'transparent',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'rgba(218, 224, 233, 0.04)',
    },
  },
}));

const BorderButton = ({
  className = '',
  onClick = () => {},
  children = '',
}) => {
  const classes = useStyles();

  return (
    <button className={`${classes.root} ${className}`} onClick={onClick}>
      {children}
    </button>
  );
};

export default BorderButton;
